import K from '../constants/CelebritiesConstants';
import axios from 'axios';

export const getCelebrities = () => {
    return dispatch => {
        const endpoint = `${
            process.env.REACT_APP_API_URL
        }/api/celebrities?filter={"order":"createdOn DESC"}`;
        axios
            .get(endpoint)
            .then(function(response) {
                dispatch({
                    type: K.GET_CELEBRITIES,
                    payload: response.data
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    };
};



// WEBPACK FOOTER //
// ./src/actions/CelebritiesActions.js